import { Select } from "antd"
export { LMSelect } from "./LMSelect";
export const Option = Select.Option;
export const OptGroup = Select.OptGroup;